import React, { useState, useContext } from 'react';
import PlateNumberSearch from './PlateNumberSearch';
import VehicleDetails from './VehicleDetails';
import HitList from './HitList';
import { GetData } from './Fetch';
import { SettingsContext } from "./Context";
import GrayInfoBox from './GrayInfoBox';
import { TranslationContext } from "./Context";
import ContactUs from './ContactUs';

function PlateTab(props) {
    const translation = useContext(TranslationContext);
    const [vehicle, setVehicle] = useState(null);
    const [assemblyGroups, setAssemblyGroups] = useState([]);
    const [hits, setHits] = useState(null);
    const settings = useContext(SettingsContext);
    const [contactUs, setContactUs] = useState(null);

    function handleVehicleSelected(selectedVehicle) {
        setContactUs(null);
        setVehicle(selectedVehicle);
        setHits(null)

        if (selectedVehicle) {
            GetData(`/language/${settings.language}/country/${settings.market}/vehicles/${selectedVehicle.targetType}/${selectedVehicle.typeNumber}/articles`)
                .then(data => {
                    setHits(data)
                    setAssemblyGroups(data.assemblyGroupFacets.counts);
                });
        }
    }

    function handleAssemblyGroupChange(e) {
        setContactUs(null);
        let value = null;
        if (e) {
            value = e.value;
        }
        SearchArticles(value)
            .then(data => {
                setHits(data);
            });
    }

    function SearchArticles(assemblyGroup) {
        let uri = `/language/${settings.language}/country/${settings.market}/vehicles/${selectedVehicle.targetType}/${vehicle.typeNumber}/`;
        if (assemblyGroup) {
            uri += `assemblygroups/${assemblyGroup}/`;
        }
        uri += `articles`;

        return GetData(uri);
    }

    function handleContactUsClick() {
        setContactUs(<ContactUs vehicle={vehicle} onCloseClick={(e) => setContactUs(null)} />)
    }

    const showNoVehicleFoundMessage = vehicle !== null && !vehicle;

    return (
        <div>
            <PlateNumberSearch countries={props.countries} onVehicleSelected={handleVehicleSelected} selectedCountry={props.market} />
            {vehicle &&
                <div className="partsSearchResultComponent">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="partsSearchResultComponent-wrapper">
                                    <div>
                                        <div className="text-center u-textBold18 u-absBottomMarginSm">{vehicle.manufacturerName} {vehicle.modelName} {vehicle.typeName}</div>
                                        <VehicleDetails vehicle={vehicle} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>}

            {showNoVehicleFoundMessage &&
                <GrayInfoBox>
                    <h2 className="u-textBold28">{translation["TecAlliencePartSearch.PartsSearch.Browse.NoVehicleFound"]}</h2>
                    <div className="u-mbottom20">{translation["TecAlliencePartSearch.PartsSearch.Browse.NoVehicleFoundExtraInformation"]}</div>
                </GrayInfoBox>
            }

            <div className="vehicleProductListComponent">
                {vehicle && hits && hits.articles.length > 0 &&
                    <HitList hits={hits} assemblyGroups={assemblyGroups} linkingTargetType={vehicle.targetType}
                        onAssemblyGroupChange={handleAssemblyGroupChange}
                    />}
            </div>

            {vehicle && assemblyGroups.length === 0 &&
                <GrayInfoBox>
                    <h2 className="u-textBold28">{translation["TecAlliencePartSearch.ProductList.NoHits.NoMatchesFound"]}</h2>
                    <div className="u-mbottom20">{translation["TecAlliencePartSearch.ProductList.NoHits.NoMatchesFoundExtraInformation"]}</div>
                    <p>
                        <button className="btn btn-primary u-xsBlock" onClick={handleContactUsClick}>{translation["TecAlliencePartSearch.ProductList.NoHits.ContactUs"]}</button>
                    </p>
                </GrayInfoBox>}
            {contactUs !== null && contactUs}
        </div>
    );
}

export default PlateTab;